"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * 事件类型
 * 
 * @readonly
 * @enum {string}
 */
var _default = {
  /** 模块点击事件 */
  MODULE_CLICK: 'click',

  /** 模块浏览事件 */
  MODULE_VIEW: 'showItem',

  /** 页面浏览事件 */
  PAGE_VIEW: 'page',

  /** 请求事件 */
  REQUEST: 'request',

  /** fetch 时长 */
  FETCH_DURATION: 'fetch_duration',

  /** page打开时长事件 */
  PAGE_OPEN: 'page_open'
};
exports["default"] = _default;